/**
 * Tabs for the uc-* sections. Progressive enhancement: every panel is in the HTML,
 * the first is visible, the rest carry [hidden]. Arrow keys move between tabs.
 */
(function () {
  function activate(tablist, tab) {
    queueMicrotask(() => document.dispatchEvent(new CustomEvent('uc:tabchange')));
    const section = tablist.closest('.uc-section') || document;
    const target = tab.getAttribute('data-uc-tab');
    tablist.querySelectorAll('[role="tab"]').forEach((t) => {
      const on = t === tab;
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    section.querySelectorAll('[data-uc-panel]').forEach((p) => {
      p.hidden = p.getAttribute('data-uc-panel') !== target;
    });
  }

  document.addEventListener('click', (e) => {
    const tab = e.target.closest('[data-uc-tabs] [role="tab"]');
    if (!tab) return;
    activate(tab.closest('[data-uc-tabs]'), tab);
  });

  document.addEventListener('keydown', (e) => {
    const tab = e.target.closest('[data-uc-tabs] [role="tab"]');
    if (!tab) return;
    const tablist = tab.closest('[data-uc-tabs]');
    const tabs = Array.from(tablist.querySelectorAll('[role="tab"]'));
    const i = tabs.indexOf(tab);
    let next = null;
    if (e.key === 'ArrowRight') next = tabs[(i + 1) % tabs.length];
    if (e.key === 'ArrowLeft') next = tabs[(i - 1 + tabs.length) % tabs.length];
    if (e.key === 'Home') next = tabs[0];
    if (e.key === 'End') next = tabs[tabs.length - 1];
    if (!next) return;
    e.preventDefault();
    activate(tablist, next);
    next.focus();
  });

  // Footer link columns are <details> for the mobile accordion only; on wider screens
  // they stay open even if the summary is toggled with the keyboard.
  const footerMq = window.matchMedia('(min-width: 750px)');
  const keepFooterOpen = () => {
    if (!footerMq.matches) return;
    document.querySelectorAll('.uc-footer__col').forEach((d) => (d.open = true));
  };
  document.addEventListener('toggle', (e) => {
    if (e.target.classList && e.target.classList.contains('uc-footer__col') && footerMq.matches && !e.target.open) e.target.open = true;
  }, true);
  footerMq.addEventListener('change', keepFooterOpen);
  keepFooterOpen();

  document.querySelectorAll('[data-uc-tabs]').forEach((tablist) => {
    tablist.querySelectorAll('[role="tab"]').forEach((t) => {
      t.tabIndex = t.getAttribute('aria-selected') === 'true' ? 0 : -1;
    });
  });
})();
